import cx from "classnames";
import { Form, Formik } from "formik";

import { Button, Col, Divider, Modal, Row, Space } from "antd";
import SubInfoSwitch from "components/elements/InfoSwitch/SubInfoSwitch";
import { Input, Select } from "components/form";

import schema from "../../../features/company/schemas/companyOrganizationSchema";
import styles from "./Modal.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function ModalOrganization({
  node = [],
  title = "",
  width = 975,
  className = "",
  back = "CANCEL",
  submit = "SAVE",
  blankForm = false,
  isCompany = false,
  isModalOpen = false,
  acountTypeOption = [],
  organizationLevelOption = [],
  organizationUnderOptions = [],
  socialSecurityBranchOptions = [],
  handleOk = () => { },
  onSubmit = () => { },
  handleCancel = () => { },
}) {
  const onCancel = () => {
    const cancelBtn = document.getElementById("organization__cancelBtn");
    if (cancelBtn) {
      cancelBtn.click();
    } else {
      handleCancel();
    }
  };

  const { t } = useTranslation();
  const roles = useSelector((state) => state.company.roles);
  const canEdit = roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION");
  const canCreate = roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION");

  console.log("nodenode", title, node, organizationUnderOptions, blankForm);

  const shouldDisableField = () => {
    if (submit.toUpperCase() === 'CREATE') {
      return !canCreate;
    } else {
      return canCreate && !canEdit;
    }
  };

  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={onCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      maskClosable={false}
      closable={false}
      destroyOnClose
    >
      <Formik
        enableReinitialize
        initialValues={{
          isCompany: isCompany,
          information: node.accountInformation === "Y",
          level: isCompany
            ? organizationLevelOption.find((e) => e.level === 1).value
            : parseInt(node.level),
          under: title.match('(Edit|แก้ไขข้อมูล)') ? node?.under?.id : node.organizationId,
          agencyCode: blankForm ? "" : node.departmentCode,
          organizationLevelNameTH: blankForm ? "" : node.organizationName,
          organizationLevelNameEN: blankForm ? "" : node.organizationNameEn,
          costCenter: blankForm ? "" : node.costCenter,
          businessUnit: blankForm ? "" : node.businessUnit,
          accountTypeCodes: blankForm ? "" : node.accountTypeCodes?.id,
          socialSecurityBranchOptions: blankForm
            ? ""
            : node?.socialSecurityBranch?.branchId,
        }}
        validationSchema={schema}
        onSubmit={(values) => {
          onSubmit(values, onCancel);
        }}
      >
        {({ values = {}, setFieldValue = () => { }, resetForm = () => { } }) => {
          return (
            <Form>
              <Space
                className={styles.container}
                size={24}
                direction="vertical"
              >
                <Divider />
                <Row gutter={[8, 24]}>
                  <Col span={12}>
                    <Select
                      disabled
                      name="level"
                      label={t("organization.label.level")}
                      placeholder={t("organization.label.level")}
                      size="large"
                      options={organizationLevelOption}
                    />
                  </Col>
                  {isCompany === false ? (
                    <Col span={12}>
                      <Select
                        disabled
                        name="under"
                        label={t("organization.label.under")}
                        placeholder={t("organization.label.under")}
                        size="large"
                        options={organizationUnderOptions}
                      />
                    </Col>
                  ) : (
                    <Col span={12}></Col>
                  )}
                  <Col span={12}>
                    <Input
                      name="agencyCode"
                      label={
                        t("organization.label.agency_code")
                      }
                      placeholder={t('organization.label.agency_code_placeholder')}
                      size="large"
                      disabled={shouldDisableField()}
                      required
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      name="organizationLevelNameTH"
                      label={
                        t("organization.label.name_th")
                      }
                      placeholder={t('organization.label.organization_level_name_th_placeholder')}
                      size="large"
                      disabled={shouldDisableField()}
                      required
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      name="organizationLevelNameEN"
                      label={
                        t("organization.label.name_en")
                      }
                      placeholder={t('organization.label.organization_level_name_en_placeholder')}
                      size="large"
                      disabled={shouldDisableField()}
                      required
                    />
                  </Col>
                  {(isCompany === false && values.level < 3) ? (
                    <Col span={12}>
                      <Select
                        name="socialSecurityBranchOptions"
                        label={t("organization.label.social_security_branch")}
                        placeholder={t('please-select-1')}
                        size="large"
                        options={socialSecurityBranchOptions}
                        disabled={shouldDisableField()}
                      />
                    </Col>
                  ) : (
                    <Col span={12}></Col>
                  )}
                  <Col span={12} style={{ paddingTop: "12px" }}>
                    <SubInfoSwitch
                      label={t("organization.label.account_information")}
                      subClassName={styles.label}
                      value={values.information}
                      onChange={(e) => {
                        setFieldValue("information", !values.information);
                      }}
                      disabled={shouldDisableField()}
                    />
                  </Col>
                  <Col span={12}></Col>
                  {values.information ? (
                    <Col span={24}>
                      <Row gutter={[24, 10]}>
                        <Col span={12}>
                          <Select
                            name="accountTypeCodes"
                            label={
                              t("organization.label.account_type_codes")
                            }
                            placeholder={t('organization.label.account_type_codes_placeholder')}
                            size="large"
                            options={acountTypeOption}
                            disabled={shouldDisableField()}
                            required
                          />
                        </Col>
                        <Col span={6}>
                          <Input
                            name="costCenter"
                            label={t("organization.label.cost_center")}
                            placeholder="Cost Center"
                            disabled={shouldDisableField()}
                            size="large"
                          />
                        </Col>
                        <Col span={6}>
                          <Input
                            name="businessUnit"
                            label={t("organization.label.business_unit")}
                            placeholder={t("organization.label.business_unit")}
                            disabled={shouldDisableField()}
                            size="large"
                          />
                        </Col>
                      </Row>
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="organization__cancelBtn"
                      key="back"
                      onClick={() => {
                        handleCancel();
                        resetForm();
                      }}
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t('action.cancel')}
                    </Button>
                    {(!shouldDisableField()) &&
                      <Button
                        htmlType="submit"
                        type="primary"
                        style={{ height: "40px", backgroundColor: "var(--button-color)", borderRadius: "8px" }}
                      >
                        {submit == 'CREATE' ? t('create-1') : t('action.save')}
                      </Button>}
                  </Space>
                </Row>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default ModalOrganization;
